import { render } from "./Weightroom2.vue?vue&type=template&id=3f21943d&scoped=true"
import script from "./Weightroom2.vue?vue&type=script&lang=js"
export * from "./Weightroom2.vue?vue&type=script&lang=js"

import "./Weightroom2.vue?vue&type=style&index=0&id=3f21943d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f21943d"]])

export default __exports__